/**
 * TanStack Query hooks for `auto-alert-publisher-manager-email`.
 * Thin wrappers over ./api for list / create / markSent.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	markSent,
	autoAlertPublisherManagerEmailQueryKeys,
	type AlertStatus,
	type CreateAutoAlertPublisherManagerEmailBody,
	type CreateAutoAlertPublisherManagerEmailResponse,
	type ListAutoAlertPublisherManagerEmailResponse,
	type MarkSentResponse,
} from "./api";

export function useAutoAlertPublisherManagerEmailList(
	status?: AlertStatus,
): UseQueryResult<ListAutoAlertPublisherManagerEmailResponse, Error> {
	return useQuery({
		queryKey: autoAlertPublisherManagerEmailQueryKeys.list(status),
		queryFn: () => list(status),
	});
}

export function useAutoAlertPublisherManagerEmailCreate(): UseMutationResult<
	CreateAutoAlertPublisherManagerEmailResponse,
	Error,
	CreateAutoAlertPublisherManagerEmailBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: autoAlertPublisherManagerEmailQueryKeys.all,
			});
		},
	});
}

export function useAutoAlertPublisherManagerEmailMarkSent(): UseMutationResult<
	MarkSentResponse,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: markSent,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: autoAlertPublisherManagerEmailQueryKeys.all,
			});
		},
	});
}
